"use client";

import { useActionState } from "react";
import { useTranslations } from "next-intl";
import {
  submitContactAction,
  type ContactFormState,
} from "@/lib/actions/contact";

const initial: ContactFormState = {};

export function ContactForm() {
  const t = useTranslations("contact");
  const [state, formAction, pending] = useActionState(
    submitContactAction,
    initial,
  );

  return (
    <form action={formAction} className="mt-6 max-w-lg space-y-3">
      <input
        name="name"
        required
        placeholder={t("name")}
        className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm"
      />
      <input
        name="email"
        type="email"
        required
        placeholder={t("email")}
        className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm"
      />
      <textarea
        name="message"
        required
        rows={5}
        placeholder={t("message")}
        className="w-full rounded-md border border-stone-300 px-3 py-2 text-sm"
      />
      {state.error ? (
        <p className="text-sm text-red-800">{t("errors.invalid")}</p>
      ) : null}
      {state.success ? (
        <p className="text-sm text-emerald-800">{t("sent")}</p>
      ) : null}
      <button
        type="submit"
        disabled={pending}
        className="rounded-md bg-stone-900 px-4 py-2.5 text-sm font-medium text-white hover:bg-stone-800 disabled:opacity-60"
      >
        {pending ? t("sending") : t("submit")}
      </button>
    </form>
  );
}
